// extracted by mini-css-extract-plugin
export default {"Container":"Parameter_Container__SGYl5","Error":"Parameter_Error__OnBaj","NumberSelect":"Parameter_NumberSelect__VozDk","Reset":"Parameter_Reset__U8evL"};